/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_DescriptionInputs */

const en_auth_login_description = /** @type {(inputs: Auth_Login_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to book, move or cancel a session.`)
};

const pl_auth_login_description = /** @type {(inputs: Auth_Login_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, żeby zarezerwować, przenieść albo odwołać zajęcia.`)
};

/**
* | output |
* | --- |
* | "Sign in to book, move or cancel a session." |
*
* @param {Auth_Login_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_description = /** @type {((inputs?: Auth_Login_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_description(inputs)
	return en_auth_login_description(inputs)
});